import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

export const ColorsFormWrapper = styled('div', { label: 'ColorsFormWrapper' })`
    margin-left: 8px;
`;

interface ColorPreviewPropsType {
    textColor: string;
    bgColor: string;
    dataTest?: string;
}

export const BackgroundPreview = withConfig(theme => styled('div', { label: 'BackgroundPreview' })<ColorPreviewPropsType>`
    display: flex;
    height: 96px;
    width: 100%;
    background-color: ${({ bgColor }): string => bgColor === '' ? theme.colorPicker.bgDefault : bgColor};
    color: ${({ textColor }): string => textColor === '' ? theme.colorPicker.txtDefault : textColor};
    align-items: center;
    margin: 8px 0 16px;
    border-radius: 4px;
`);

export const LabelPreview = styled('div', { label: 'LabelPreview' })`
    font-family: "Montserrat", Arial, Tahoma, sans-serif;
    margin-left: 16px;
    font-size: ${fontSize.big};
    font-weight: ${fontWeight.bold};
    line-height: 1.25;
`;
